import React, { useEffect, useState } from "react"
import Col from "@bappweb/col"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Block from "@bappweb/block"
import MainForm from "./form"
import LandingHeader from "./landingheader"
import { useGetConfigListMutation } from "../../../api/services"
import { getCidParameter, getConfigValue, SMPUConfigListResponse } from "@smpu-web/utils/utils"
import { pushGtmValues } from "@bappweb/utils"

const Landing = () => {
  const [getConfigList] = useGetConfigListMutation();
  const [configList, setConfigList] = useState<SMPUConfigListResponse[]>()
  useEffect(() => {
    getConfigList({
      functionCode: "SPE0021",
      cid: getCidParameter() ?? "",
      TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          setConfigList(payload.configList)
        }
      })
  }, [])
  useEffect(() => {
    pushGtmValues({
      event: "virtual_page_view",
      content_group: "1e1_bankacilik",
      pageName: "/basvuru/1e1-bankacilik/0/landing",
      pageTitle: '1e1 Bankacılık'
    })
  }, []);
  return (
    <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
      <LandingHeader configValue={getConfigValue(configList, "BirebirBankacilik.CampaignText.Landing.Top")} />
      <Grid type="main" className="landing-page-main">
        <Row>
          <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
            <MainForm configValue={getConfigValue(configList, "BirebirBankacilik.CampaignText.Landing.Bottom")} />
          </Col>
        </Row>
      </Grid>
    </Block>
  )
}

export default Landing
